module.exports = __webpack_public_path__ + "media/bg/bg-7-821bf3c3.jpg";